import * as React from 'react'
import LiveBadge from './LiveBadge'
import TextLiveStatus from './TextLiveStatus'
import TimeInfo from './TimeInfo'
import { StorefrontItemLive } from 'DVWebNodeUtils';

interface LiveStatusProps extends StorefrontItemLive {
  isStandalone?: boolean
}

const LiveStatus = ({ label, status, isStandalone, timeBadge }: LiveStatusProps) => {
  if (!status || !label) {
    return timeBadge && isStandalone
      ? <TimeInfo label={timeBadge} /> : null
  }
  if (status === 'LIVE') {

    return (
      <div><LiveBadge label={label} status={status} isStandalone={isStandalone} />
        {isStandalone && (<TimeInfo label={timeBadge} />)}
      </div>
    )
  }
  return (
    <div>
      <TextLiveStatus label={label} />
      {isStandalone && (<TimeInfo label={timeBadge} />)}
    </div>
  )
}

export default LiveStatus
